/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Pro_15Inputs */



/**
* | output |
* | --- |
* | "AI Agent included" |
*
* @param {Signup_Feature_Pro_15Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_pro_15 = /** @type {((inputs?: Signup_Feature_Pro_15Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Pro_15Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("AI Agent included")
	if (locale === "de") return /** @type {LocalizedString} */ ("AI Agent included")
	if (locale === "it") return /** @type {LocalizedString} */ ("AI Agent included")
	if (locale === "ru") return /** @type {LocalizedString} */ ("AI Agent included")
	if (locale === "es") return /** @type {LocalizedString} */ ("AI Agent included")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("AI Agent included")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AI Agent included")
	if (locale === "hi") return /** @type {LocalizedString} */ ("AI Agent included")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("AI Agent included")
	return /** @type {LocalizedString} */ ("AI Agent included")
});